export class Maaler {
    public ejendomNr: number;
    public info1: string;
    public info2: string;
    public installationNr: number;
    public maalerNr: string;
    public maalerTypeNr: number;
    public opsatDato: Date;
    public sidsteServiceDato: Date;
}

export function opretTomMaaler(): Maaler {
    return {
        ejendomNr: 0,
        info1: "",
        info2: "",
        installationNr: 0,
        maalerNr: "",
        maalerTypeNr: 0,
        opsatDato: null,
        sidsteServiceDato: null
    };
}

export const nullInstallationNr = 0;
